export default __webpack_public_path__ + "static/media/Kaiku_normal.2894d614.png";